@if (!isMobileModalPathActive()) {
  <app-dropdown
    #dropdownRef
    [componentWithDataSetter]="contentSetter()"
    [widthInPX]="'517px'"
    [minWidthInPX]="'517px'"
    [dropdownListXPosition]="'right'"
    [dropdownListYPosition]="'remain_at_bottom'"
  >
    <div
      class="tw-flex tw-items-center tw-gap-2 tw-min-w-0 tw-cursor-pointer tw-p-1 tw-rounded-md hover:tw-bg-gray-200 tw-transition-colors"
    >
      <svg width="16" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M9 0C7.21997 0 5.47991 0.527841 3.99987 1.51677C2.51983 2.50571 1.36628 3.91131 0.685088 5.55585C0.00389956 7.20038 -0.17433 9.00998 0.172937 10.7558C0.520203 12.5016 1.37737 14.1053 2.63604 15.364C3.89472 16.6226 5.49836 17.4798 7.24419 17.8271C8.99002 18.1743 10.7996 17.9961 12.4442 17.3149C14.0887 16.6337 15.4943 15.4802 16.4832 14.0001C17.4722 12.5201 18 10.78 18 9C17.9974 6.61385 17.0483 4.32619 15.3611 2.63893C13.6738 0.951673 11.3861 0.00262044 9 0V0ZM12.5838 12.5838C12.415 12.7525 12.1861 12.8473 11.9475 12.8473C11.7089 12.8473 11.48 12.7525 11.3112 12.5838L8.3646 9.6372C8.19625 9.46772 8.10123 9.23888 8.1 9V5.4C8.1 5.1613 8.19482 4.93239 8.36361 4.7636C8.53239 4.59482 8.76131 4.5 9 4.5C9.2387 4.5 9.46762 4.59482 9.6364 4.7636C9.80518 4.93239 9.9 5.1613 9.9 5.4V8.6274L12.5838 11.3112C12.7525 11.48 12.8473 11.7088 12.8473 11.9475C12.8473 12.1861 12.7525 12.415 12.5838 12.5838V12.5838Z"
          fill="#111928"
        />
      </svg>

      <span class="tw-text-gray-900 tw-text-sm md:tw-text-base tw-font-inter tw-truncate">
        {{ displayLabel() }}
      </span>
    </div>
  </app-dropdown>
} @else {
  <div
    class="tw-flex tw-items-center tw-gap-2 tw-min-w-0 tw-cursor-pointer tw-p-1 tw-rounded-md hover:tw-bg-gray-200 tw-transition-colors"
    (click)="openMobileModal($event)"
  >
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 0C7.21997 0 5.47991 0.527841 3.99987 1.51677C2.51983 2.50571 1.36628 3.91131 0.685088 5.55585C0.00389956 7.20038 -0.17433 9.00998 0.172937 10.7558C0.520203 12.5016 1.37737 14.1053 2.63604 15.364C3.89472 16.6226 5.49836 17.4798 7.24419 17.8271C8.99002 18.1743 10.7996 17.9961 12.4442 17.3149C14.0887 16.6337 15.4943 15.4802 16.4832 14.0001C17.4722 12.5201 18 10.78 18 9C17.9974 6.61385 17.0483 4.32619 15.3611 2.63893C13.6738 0.951673 11.3861 0.00262044 9 0V0ZM12.5838 12.5838C12.415 12.7525 12.1861 12.8473 11.9475 12.8473C11.7089 12.8473 11.48 12.7525 11.3112 12.5838L8.3646 9.6372C8.19625 9.46772 8.10123 9.23888 8.1 9V5.4C8.1 5.1613 8.19482 4.93239 8.36361 4.7636C8.53239 4.59482 8.76131 4.5 9 4.5C9.2387 4.5 9.46762 4.59482 9.6364 4.7636C9.80518 4.93239 9.9 5.1613 9.9 5.4V8.6274L12.5838 11.3112C12.7525 11.48 12.8473 11.7088 12.8473 11.9475C12.8473 12.1861 12.7525 12.415 12.5838 12.5838V12.5838Z"
        fill="#111928"
      />
    </svg>

    <span class="tw-text-gray-900 tw-text-base tw-font-inter tw-truncate">
      {{ displayLabel() }}
    </span>
  </div>
}

@if (useModalOnMobile()) {
  <modal
    [id]="mobileModalId"
    [header]="mobileModalTitle()"
    [headerIcon]="mobileModalHeaderIcon"
    [showHeader]="true"
    [showHeaderDivider]="true"
    [showFooterDivider]="false"
    [heightClass]="'tw-h-auto'"
    [widthClass]="'event-dates-modal-shell--picker'"
    [enableBackdropClose]="true"
  >
    <div slot="body" class="tw--mx-2 tw--mt-1">
      <app-time-range-picker-content #modalPickerContent [inModal]="true"></app-time-range-picker-content>
    </div>
  </modal>
}
